export async function idyuGetDataContainer() {
  const data = await fetch("/refapi/pdata?lang=FRA");
  const res = await data.json();
  return res;
}

export async function idyuGetCountries() {
  const data = await fetch("/refapi/countries");
  const res = await data.json();
  return res;
}

export async function idyuGetRegions(id) {
  const data = await fetch("/refapi/regions?id=" + id);
  const res = await data.json();
  return res;
}

export async function idyuGetDepartments(id) {
  const data = await fetch("/refapi/departments?id=" + id);
  const res = await data.json();
  return res;
}

export function idyuSalesStatus(status) {
  if (status == 0) return "<span class='black'> En attente </span>";
  if (status == 1) return "<span class='black'> Payé </span>";
  if (status == 2) return "<span class='green'> Validé </span>";
  if (status >= 11) return "<span class='orange'> Refusé </span>";
  if (status == -10) return "<span> Remboursé </span>";
  if (status == -1) return "<span class='red'> Impayé </span>";
  if (status == -2) return "<span class='red'> Annulé </span>";
  if (status == -3) return "<span class='red'> Remboursé </span>";
  return "";
}
